export const CONFIG = {
  LOCUS_API: {
    BASE_URL: "https://api.locus-api.com/v1",
    OMS_BASE_URL: "https://oms.locus-api.com/v1",
    "LILY_BASE_URL_watson-devo":
      "https://watson-lily-pre-prod.locus-api.com/v1",
    "LILY_BASE_URL_watsons-my": "https://watson-lily.locus-api.com/v1",
    "LILY_BASE_URL_watsons-ph": "https://watson-lily.locus-api.com/v1",
  }
};
